export class AsyncForm
{
    static bindEvents(form)
    {
        let that = this;

        // Create CAPTCHAs
        if (typeof form.dataset.captcha !== 'undefined') {
            // Create element
            let captchaElm = document.createElement('div');
            captchaElm.classList.add('captcha', 'not-rendered');
            form.appendChild(captchaElm);

            form.addEventListener('submit', (e) => {
                e.preventDefault();
                that.renderCaptcha(form, captchaElm);
            });
        } else {
            form.addEventListener('submit', (e) => {
                e.preventDefault();
                that.submit(form);
            });
        }
    }

    static renderCaptcha(form, captchaElm)
    {
        // Render captcha to form element
        if (captchaElm.classList.contains('not-rendered')) {
            captchaElm.classList.remove('not-rendered');

            form.dataset.captchaid = window.bo.captcha.render(captchaElm, {
                'size': 'invisible',
                'callback': response => {
                    this.submit(form, response);
                },
            });
        }

        // Submit form
        this.submit(form);
    }
    
    static submit(form, captchaResponse = null) {
        if (form.classList.contains('loading')) {
            return false;
        }

        let formSubmitBtn = form.querySelector('button[type=submit]');
        if (formSubmitBtn && formSubmitBtn.classList.contains('disabled')) {
            let scrollElm = form.querySelector('.invalid,input:invalid');
            if (scrollElm) {
                scrollElm.style.scrollMarginTop = document.querySelector('header').offsetHeight + 20 + 'px';
                scrollElm.scrollIntoView();
            }
            return false;
        }

        if (captchaResponse === null) {
            // Not having a captcha response means this is the first time invoking the submit function
            if ('captcha' in form.dataset && window.bo.captcha.isEnabled()) {
                // Defined data-captcha means captcha is required, so execute the captcha
                if ('captchaid' in form.dataset) {
                    // Captcha needs to be rendered first
                    window.bo.captcha.execute(form.dataset.captchaid);
                }

                // Stop here, captcha resubmits the form after getting a response
                return false;
            }
        }

        let postUrl = form.getAttribute('action');
        let formData = new FormData(form);

        if(document.activeElement && document.activeElement.name && document.activeElement.value) {
            formData.append(document.activeElement.name, document.activeElement.value);
        }

        let loadingTimeout = setTimeout(() => {
            if (!form.classList.contains('loading')) {
                form.classList.add('loading');

                let overlay = document.createElement('div');
                overlay.classList.add('overlay');
                form.appendChild(overlay);

                window.bo.loaderElement.appendTo(overlay);
            }
        }, 100);

        window.bo.ajax.post(postUrl, formData).onLoad(async (xhr) => {
            if (form.hasAttribute('data-callback-event')) {
                document.dispatchEvent(new Event(form.getAttribute('data-callback-event')));
            }
            const {AsyncFormCallbacks} = await import('./AsyncFormCallbacks.js');

            if (typeof form.dataset.callback !== 'undefined' &&
                typeof AsyncFormCallbacks[form.dataset.callback] === 'function') {
                // If a callback function exists, run it
                AsyncFormCallbacks[form.dataset.callback](form, xhr);
            } else {
                // Otherwise run the default "generic" callback
                AsyncFormCallbacks.generic(xhr);
            }
        }).onEnd(() => {
            clearTimeout(loadingTimeout);
            form.classList.remove('loading');
            let overlay = form.querySelector('.overlay');
            if (overlay) {
                overlay.remove();
            }

            if ('captchaid' in form.dataset) {
                window.bo.captcha.reset(form.dataset.captchaid);
            }
        });
    }
}
